import { BidEvalProjectWebResult } from "./project"
import { Question } from "./question"

// Mirrors the C# BatchProcessParameters. `workflow` is the unified
// batchtypestring that drives the answer pipeline + optional trace /
// score / improvements per the gen* flags. `tracing` / `scoring` /
// `evaluate` are kept for backwards compat with anything still using
// them, but new code should default to `workflow`.
export enum BatchType {
  none = "none",
  workflow = "workflow",
  answer = "answer",
  evaluate = "evaluate",
  tracing = "tracing",
  scoring = "scoring",
  improvements = "improvements",
  wintheme = "wintheme",
}

export interface FilterItem {
  // shape unknown on the TS side; tighten if/when we surface filters
  [k: string]: any
}

export interface BatchProcessArgs {
  projectsha: string
  questions: Question[]
  batchtypestring: BatchType
  pickselected: string
  n: number
  stylename: string
  gensources: boolean
  genstructure: boolean
  genanswer: boolean
  gentrace: boolean
  genscore: boolean
  genimprovements: boolean
  // project-level flag, but the C# side groups it with the per-batch
  // parameters so it lives here too.
  genwintheme: boolean
  projectfileshas: string[]
  pickmin: string
  pickauto: boolean
  charcount: boolean
  includelist: FilterItem[]
  excludelist: FilterItem[]
  projectbideval: BidEvalProjectWebResult
}
